import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="px-4 py-16" data-id="element-118">
      <div className="max-w-3xl mx-auto text-center" data-id="element-119">
        <div className="flex justify-center mb-6" data-id="element-120">
          <ShieldCheck className="w-16 h-16 text-brand-amber" data-id="element-121" />
        </div>
        <h2 className="mb-4 text-2xl font-bold md:text-3xl text-brand-teal" data-id="element-122">
          Garantía de 7 días (sin vueltas) 🔒
        </h2>
        <p className="text-lg text-brand-dark/80 leading-relaxed" data-id="element-123">
          Estamos tan seguros de la calidad de este material que te ofrecemos
          una garantía total. Si comprás el MegaPack, lo revisás y sentís que no
          conecta con tu forma de aprender o no te sirve para tus lecturas, nos
          escribís dentro de los primeros 7 días y te devolvemos el 100% de tu
          dinero. Sin preguntas incómodas.
        </p>
      </div>
    </section>;
}